import React from 'react';
import {compose} from 'redux';
import {withRouter} from 'react-router';

import styles from './SuccessModal.module.scss';

import config from '../../../config/config';
import thumbsUpImg from '../../../assets/images/thumbsUp.svg';

const SuccessModal = ({
  onClose,
  history,
  isEdit = false,
  isDelete = false,
}) => {
  return (
    <div>
      <div className={styles.container}>
        {(isDelete || isEdit) && (
          <img src={thumbsUpImg} alt="" className={styles.thumbsUp} />
        )}
      </div>
      <div className={styles.container}>
        {isDelete ? (
          <div className={styles.deleteTitle}>
            Your request to delete your{' '}
            <span className="orphan-line">Auto-RMD</span> has been submitted.
          </div>
        ) : (
          <div className={styles.title}>
            {isEdit ? (
              'You have updated your Auto-RMD.'
            ) : (
              <div className={styles['success-container']}>
                <p className={styles['success-header']}>
                  You have submitted your Auto-RMD.
                </p>
                <p className={styles['success-message']}>
                  Congratulations, you have successfully submitted your
                  Auto-RMD. Please note that details related to your RMD will be
                  available on your automatic transactions page in approximately
                  5 business days.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles['button-container']}>
        <button
          id="success-modal-close"
          className={styles.leave}
          onClick={(e) => {
            //onClose();
            window.location.href = `${config.url}/usis/rmd-tool`;
          }}
        >
          Return to RMD dashboard
        </button>
      </div>
    </div>
  );
};

export default compose(withRouter)(SuccessModal);
